import { TNote } from "~/types";
import { baseService } from "../base";
import { PaginationResponse } from "../type";
import { CreateNoteParams, GetNoteParams } from "./note.types";

export const noteServices = {
  getNotes: async (params?: GetNoteParams) => {
    const { data } = await baseService.get<PaginationResponse<TNote>>("notes", {
      params,
    });
    return data;
  },
  createNote: async (params: CreateNoteParams) => {
    const { data } = await baseService.post<TNote>("notes", params);
    return data;
  },
};
